import { Injectable } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import {
  daLocale,
  defineLocale,
  fiLocale,
  svLocale,
  getSetGlobalLocale,
} from 'ngx-bootstrap/chronos';
import {
  nlLocale,
  trLocale,
  enGbLocale,
  deLocale,
  esLocale,
  frLocale,
  itLocale,
} from 'ngx-bootstrap/locale';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DatepickerLocaleService {
  private currentLocaleSubject = new BehaviorSubject<string>('');
  public currentLocale$ = this.currentLocaleSubject.asObservable();

  constructor(private bsLocaleService: BsLocaleService) {
    this.registerLocales();
    this.setLocaleFromStorage();
  }

  private registerLocales(): void {
    defineLocale('en', enGbLocale);
    defineLocale('nl', nlLocale);
    defineLocale('tr', trLocale);
    defineLocale('de', deLocale);
    defineLocale('es', esLocale);
    defineLocale('fr', frLocale);
    defineLocale('it', itLocale);
    defineLocale('sv', svLocale);
    defineLocale('da', daLocale);
    defineLocale('fi', fiLocale);
    defineLocale('no', enGbLocale);
  }

  setLocale(lang: string): void {
    getSetGlobalLocale(lang);

    this.bsLocaleService.use(lang);

    this.currentLocaleSubject.next(lang);
  }

  setLocaleFromStorage(): void {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.setLocale(userLang);
  }
}
